import { render, staticRenderFns } from "./noticeBar.vue?vue&type=template&id=c4010bf4&scoped=true"
import script from "./noticeBar.vue?vue&type=script&lang=js"
export * from "./noticeBar.vue?vue&type=script&lang=js"
import style0 from "./noticeBar.vue?vue&type=style&index=0&id=c4010bf4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4010bf4",
  null
  
)

export default component.exports